import * as React from 'react'

function SvgHourglassIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v2.877a5 5 0 0 0 3.787 4.85l1.09.273-1.09.272A5 5 0 0 0 13 25.123V28h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H27v-2.877a5 5 0 0 0-3.787-4.85L22.123 20l1.09-.272A5 5 0 0 0 27 14.877V12h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-15ZM25 28H15v-.318l.03-.013c.416-.167.99-.407 1.63-.695 1.043-.469 2.312-1.09 3.34-1.757 1.027.667 2.297 1.288 3.34 1.757.64.288 1.214.528 1.63.695l.03.013V28Zm0-2.483c-.258-.11-.542-.232-.84-.366-1.243-.56-2.655-1.272-3.56-1.951l-.6-.45-.6.45c-.905.679-2.318 1.391-3.56 1.95-.298.135-.582.258-.84.367v-.394a3 3 0 0 1 2.272-2.91l1.09-.273c2.02-.505 2.02-3.375 0-3.88l-1.09-.273A3 3 0 0 1 15 14.877V12h10v2.877a3 3 0 0 1-2.272 2.91l-1.09.273c-2.02.505-2.02 3.375 0 3.88l1.09.273A3 3 0 0 1 25 25.123v.394Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgHourglassIcon
